var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagEuropeanUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#0052B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.001 6.26086L16.5191 7.85518H18.1953L16.8391 8.84049L17.3572 10.4348L16.001 9.44943L14.6448 10.4348L15.1628 8.84049L13.8066 7.85518H15.483L16.001 6.26086Z",
    fill: "#FFDA44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11364 9.11334L10.6074 9.87434L11.7927 8.68909L11.5304 10.3447L13.0241 11.1058L11.3684 11.368L11.1061 13.0238L10.3451 11.5301L8.68945 11.7924L9.87477 10.6071L9.11364 9.11334Z",
    fill: "#FFDA44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26172 16L7.85603 15.482V13.8057L8.84128 15.1619L10.4357 14.6439L9.45022 16L10.4357 17.3562L8.84128 16.8382L7.85603 18.1944V16.5181L6.26172 16Z",
    fill: "#FFDA44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11364 22.8866L9.8747 21.3928L8.68945 20.2075L10.3451 20.4699L11.1061 18.9762L11.3684 20.6319L13.024 20.8941L11.5305 21.6552L11.7927 23.3108L10.6074 22.1255L9.11364 22.8866Z",
    fill: "#FFDA44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.001 25.7391L15.4829 24.1448H13.8066L15.1629 23.1595L14.6448 21.5653L16.001 22.5506L17.3572 21.5653L16.8391 23.1595L18.1953 24.1448H16.519L16.001 25.7391Z",
    fill: "#FFDA44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8869 22.8866L21.3932 22.1256L20.2078 23.3109L20.4701 21.6551L18.9766 20.8941L20.6322 20.6319L20.8944 18.9762L21.6554 20.4699L23.3111 20.2075L22.1257 21.3929L22.8869 22.8866Z",
    fill: "#FFDA44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7402 16L24.1459 16.5181V18.1944L23.1606 16.8382L21.5664 17.3562L22.5517 16L21.5664 14.6439L23.1607 15.1619L24.1459 13.8057V15.482L25.7402 16Z",
    fill: "#FFDA44"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8869 9.1134L22.1258 10.6071L23.3111 11.7925L21.6554 11.5301L20.8944 13.0238L20.6322 11.3681L18.9766 11.1058L20.4701 10.3448L20.2078 8.68921L21.3932 9.87446L22.8869 9.1134Z",
    fill: "#FFDA44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEuropeanUnion);
export default __webpack_public_path__ + "static/media/flagEuropeanUnion.29d9c1f05c2cae0b5e32717d217bf9b0.svg";
export { ForwardRef as ReactComponent };